;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"8e9cf6bdc4c4ac945ca81edaffb8f8b4632d5089"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

// Androidのwebviewでのみ発生している無視したいエラー
const androidWebViewErrorMessages = [
  "Unexpected token 'else'",
  "Unexpected token '='",
  "Unexpected identifier 'https'",
];

// see: https://developer.chrome.com/docs/multidevice/user-agent/#webview-on-android
function isAndroidWebView(ua) {
  return ua.includes('Android') && /; wv\)/.test(ua);
}

Sentry.init({
  dsn:
    SENTRY_DSN ||
    'https://0dd49f1653604a899b6413337f510aa6@o104940.ingest.sentry.io/1484402',
  tracesSampleRate: 0.2,
  beforeSend(event, hint) {
    const error = hint.originalException;
    const ua = event.request.headers['User-Agent'];

    if (
      isAndroidWebView(ua) &&
      error &&
      error.message &&
      androidWebViewErrorMessages.includes(error.message)
    ) {
      return null;
    }

    // 手動で送るもの以外は全て止める
    // エラーすべてを自動で送るとquotaをすぐに超えてしまうことと、環境依存のエラーが多く狼少年になってしまうため
    // captureException をデフォルトで使用すると type === 'generic' OR undefined になることを利用して判定する
    try {
      const exception = event.exception?.values?.[0];
      if (
        exception?.mechanism?.type === 'onerror' ||
        exception?.mechanism?.type === 'onunhandledrejection' ||
        exception?.mechanism?.type === 'instrument'
      ) {
        return null;
      }
    } catch (e) {}

    return event;
  },
});
